import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Formik, FormikHelpers } from 'formik';
import {
  AppFormikDatePicker,
  AppFormikTextArea,
  AppPrimaryButton,
} from 'shared/components/AppComponents';
import { Toast, Utils } from 'shared/helpers';
import { PoliciesService } from 'services';
import { IPolicy } from '../../Main';

interface IReviewPolicyProps {
  open: boolean;
  onClose: (reload: boolean) => void;
  policy: IPolicy;
}
const ReviewPolicy: React.FC<IReviewPolicyProps> = (props) => {
  const { open, onClose, policy } = props;

  // UI Actions
  const actionOnFormSubmit = (
    formValues: any,
    formikHelper: FormikHelpers<any>
  ): void => {
    PoliciesService.reviewPolicy(policy._id, {
      ...formValues,
    })
      .then(() => {
        Toast.showSuccessMessage('Policy marked as reviewd successfully.');
        onClose(true);
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        formikHelper.setSubmitting(false);
      });
  };

  // UI Elements
  return (
    <Dialog maxWidth="sm" fullWidth open={open}>
      <DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h3">Mark Policy as Reviewed</Typography>
          <IconButton onClick={() => onClose(false)}>
            <HighlightOffIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <Divider />

      <Formik
        initialValues={{
          notes: '',
          nextReviewDate: policy.lastReviewedDate || policy.reviewDate,
        }}
        onSubmit={(formValues, formik) => {
          actionOnFormSubmit(formValues, formik);
        }}
      >
        {({ handleSubmit, isSubmitting }) => (
          <>
            <DialogContent>
              <Typography className="f16 fw-5 mb-5">
                Policy: {policy.title}
              </Typography>
              <AppFormikDatePicker
                name="nextReviewDate"
                label="Next Review Date (Optional)"
                outerLabel
                placeholder="gg/mm/aaaa"
                renderInput={(props: any) => <TextField {...props} />}
              />
              <AppFormikTextArea
                rows={3}
                outerLabel
                name="notes"
                label="Review Notes (Optional)"
                placeholder="Add any notes about this review"
              />
            </DialogContent>
            <DialogActions>
              <AppPrimaryButton
                className="mr-4 mb-4"
                title="Mark as Reviewed"
                isLoading={isSubmitting}
                onClick={handleSubmit}
              />
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  );
};

export default ReviewPolicy;
